export default "__VITE_ASSET__BGHLvq4K__"